import AGREGAR_CONTRATO_INVENTARIO from '@/graphql/mutations/administracion/contratos/contrato/inventarios/agregarContratoInventario.gql';
import ACTUALIZAR_CONTRATO_INVENTARIO from '@/graphql/mutations/administracion/contratos/contrato/inventarios/actualizarContratoInventario.gql';
import REMOVER_CONTRATO_INVENTARIO from '@/graphql/mutations/administracion/contratos/contrato/inventarios/removerContratoInventario.gql';
import CONTRATO_INVENTARIO from '@/graphql/querys/administracion/contratos/contrato/inventario/contratoInventario.gql';
import CONTRATO_INSUMOS from '@/graphql/querys/administracion/contratos/insumos/contratoInsumos.gql';

export default {
  apollo: {
    contratoInsumos: {
      query: CONTRATO_INSUMOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
      update({ contratoInsumos }) {
        this.listadoInsumos = [
          ...contratoInsumos
            .map((insumo) => ({
              ...insumo,
              nuevaCantidad: 0,
            })),
        ];
        return this.listadoInsumos;
      },
    },
  },
  methods: {
    mixSeAgregoInsumo(insumo) {
      this.insumos.push(insumo);
    },
    mixSeremovioInsumo(index) {
      this.insumos.splice(index, 1);
    },
    mixGetTipoInsumo(tipo) {
      if (tipo === 1) return 'PERSONAL';
      if (tipo === 2) return 'MAQUINARIA';
      if (tipo === 3) return 'EQUIPO';
      return '';
    },

    async mixAgregarContratoInventario() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_INVENTARIO,
          variables: {
            inventario: this.inventario,
          },
          update: (store, { data: { agregarContratoInventario } }) => {
            const query = {
              query: CONTRATO_INVENTARIO,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoInventario } = store.readQuery(query);
            const contratoInventarioCopia = contratoInventario.slice();
            contratoInventarioCopia.push(agregarContratoInventario);
            store.writeQuery({
              ...query,
              data: {
                contratoInventario: contratoInventarioCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Contrato Inventario
    async mixActualizarContratoInventario() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_INVENTARIO,
          variables: {
            id: this.inventarioEditar.id,
            inventario: this.inventario,
          },
          update: (store, { data: { actualizarContratoInventario } }) => {
            const query = {
              query: CONTRATO_INVENTARIO,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoInventario } = data;
            const index = contratoInventario
              .findIndex((inventario) => inventario.id
                === actualizarContratoInventario.id);
            if (index !== -1) {
              contratoInventario.splice(index, 1, actualizarContratoInventario);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Contrato Inventario
    async mixEliminarContratoInventario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_INVENTARIO,
        variables: {
          id: this.contratoInventarioEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_INVENTARIO,
            variables: {
              idContrato: this.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoInventario } = data;
          const index = contratoInventario
            .findIndex((inventario) => inventario.id === this.contratoInventarioEliminar.id);
          if (index !== -1) {
            contratoInventario.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixGetContratoInsumos() {
      if (!this.contratoInsumos) return [];
      return this.contratoInsumos
        .slice()
        .map((contratoInsumo) => ({
          ...contratoInsumo,
          descripcion: `${contratoInsumo.insumo.descripcion} - (${this.mixGetTipoInsumo(contratoInsumo.insumo.tipo)})`,

        }));
    },
  },
};
